import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Ticket, Sparkles, Home, Map, Mail, Trophy } from "lucide-react";
import ShareButtons from "@/components/ShareButtons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

const PrizeDrawConfirmation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const entries = searchParams.get("entries") || "1";
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-warm flex items-center justify-center p-4 relative overflow-hidden">
      {/* Confetti animation */}
      {showConfetti && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `-10%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
            >
              <Ticket
                className="text-primary opacity-30"
                style={{
                  width: `${20 + Math.random() * 20}px`,
                  height: `${20 + Math.random() * 20}px`,
                }}
              />
            </div>
          ))}
        </div>
      )}

      <div className="w-full max-w-md space-y-6 relative z-10">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/30 blur-3xl rounded-full animate-pulse-soft" />
            <div className="relative bg-gradient-sunset p-8 rounded-full shadow-warm animate-float">
              <Trophy className="w-16 h-16 text-white" />
            </div>
          </div>
        </div>

        {/* Success Message */}
        <Card className="p-8 text-center space-y-4 shadow-warm border-border/50">
          <div className="flex justify-center">
            <Sparkles className="w-8 h-8 text-accent animate-pulse" />
          </div>
          
          <h1 className="text-3xl font-bold bg-gradient-sunset bg-clip-text text-transparent">
            You're Entered! 🎟️
          </h1>
          
          <p className="text-lg text-muted-foreground">
            You now have <span className="font-bold text-primary">{entries}</span> {Number(entries) === 1 ? 'entry' : 'entries'} in the
          </p>
          
          <div className="text-2xl font-bold text-primary">
            £10,000 Prize Draw!
          </div>

          <div className="pt-4 space-y-3">
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Sparkles className="w-4 h-4 text-accent" />
              <span>Good luck! 🍀</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-green-600">
              <Mail className="w-4 h-4" />
              <span>A confirmation email has been sent to you</span>
            </div>
          </div>
        </Card>

        {/* Share Card */}
        <Card className="p-6 text-center space-y-4 shadow-soft">
          <h3 className="font-semibold text-foreground">Share with friends!</h3>
          <p className="text-sm text-muted-foreground">
            Give others a chance to win too
          </p>
          <ShareButtons type="sent" />
        </Card>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            className="w-full bg-primary hover:bg-primary/90 shadow-soft"
            size="lg"
            onClick={() => navigate("/map")}
          >
            <Map className="w-5 h-5 mr-2" />
            Back to Map
          </Button>
          <Button
            variant="outline"
            className="w-full border-border/50"
            onClick={() => navigate("/dashboard")}
          >
            <Home className="w-5 h-5 mr-2" />
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrizeDrawConfirmation;
